import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function CalendarIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M23.5 16.625C23.5 17.6612 22.66 18.5 21.625 18.5H10.375C9.34 18.5 8.5 17.6612 8.5 16.625C8.5 15.5888 9.34 14.75 10.375 14.75H21.625C22.66 14.75 23.5 15.5888 23.5 16.625ZM15.375 21H10.375C9.34 21 8.5 21.8388 8.5 22.875C8.5 23.9112 9.34 24.75 10.375 24.75H15.375C16.41 24.75 17.25 23.9112 17.25 22.875C17.25 21.8388 16.41 21 15.375 21ZM31 10.375V24.125C31 27.9162 27.915 31 24.125 31H7.875C4.085 31 1 27.9162 1 24.125V10.375C1 6.58375 4.085 3.5 7.875 3.5H8.5V2.875C8.5 1.83875 9.34 1 10.375 1C11.41 1 12.25 1.83875 12.25 2.875V3.5H19.75V2.875C19.75 1.83875 20.59 1 21.625 1C22.66 1 23.5 1.83875 23.5 2.875V3.5H24.125C27.915 3.5 31 6.58375 31 10.375ZM27.25 24.125V12.25H4.75V24.125C4.75 25.8475 6.15125 27.25 7.875 27.25H24.125C25.8487 27.25 27.25 25.8475 27.25 24.125Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
